import * as React from 'react';
import {
  Box,
  Button,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  SpaceBetween,
  TextContent,
} from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { DEFAULT_CONTENT_TYPE, OMNI_WIKI_PAGE, WEBSITE_NAME } from 'src/commons/constants';
import './style.css';
import { Page } from 'src/routes';
import { CommonPageProps } from 'src/components/common/CommonPageProps';

const graph = require('./Omni.png');

interface HomeProps extends CommonPageProps {
  getStartedBtnText?: string;
}

export class Home extends React.Component<HomeProps> {
  componentDidMount() {
    const { setContentType, setNavigationOpen } = this.props;
    setContentType(DEFAULT_CONTENT_TYPE);
    setNavigationOpen(false);
  }

  onGetStarted = () => {
    this.props.setRedirect(this.props.getStartedTarget);
    this.props.setNavigationOpen(true);
    if (this.props.getStartedTarget?.endsWith(Page.SEARCH)) this.props.setDisplaySplitPanel(true);
  };

  onOnboarding = () => {
    this.props.setRedirect('/onboarding');
    this.props.setNavigationOpen(true);
  };

  static defaultProps = {
    getStartedBtnText: 'Discover data',
  };

  render() {
    return (
      <ContentLayout
        header={
          <Grid gridDefinition={[{ colspan: { xxs: 12 } }]}>
            <div className={'custom-home__header'}>
              <Grid gridDefinition={[{ offset: { l: 1, xxs: 1 }, colspan: { l: 8, xxs: 10 } }]}>
                <div className='custom-home__category'>AWS Data Platform</div>
              </Grid>

              <Grid gridDefinition={[{ colspan: { xl: 6, l: 6, s: 6, xxs: 10 }, offset: { l: 1, xxs: 1 } }]}>
                <div className={'custom-home__header-title'}>
                  <Box color={'inherit'} fontSize='display-l' fontWeight='bold'>
                    {WEBSITE_NAME}
                  </Box>
                  <Box color={'inherit'} fontSize='display-l' fontWeight={'light'}>
                    Easily discover and securely share data with fine-grained access control in AWS.
                  </Box>
                  <p>
                    {WEBSITE_NAME} is a one-stop AWS wide consolidated data catalog and an enterprise data management
                    service that makes it faster and easier to discover, share, access, and govern data stored across
                    AWS Data Lakes and Data Warehouses.
                  </p>
                </div>
              </Grid>
            </div>
          </Grid>
        }
      >
        <Grid
          gridDefinition={[
            { colspan: { xl: 6, l: 6, s: 6, xxs: 10 }, offset: { l: 1, xxs: 1 } },
            { colspan: { xl: 2, l: 3, s: 4, xxs: 10 }, offset: { s: 0, xxs: 1 } },
          ]}
        >
          <SpaceBetween size={'xl'} direction={'vertical'}>
            <div>
              <Box variant={'h1'}>How it works</Box>
              <Container media={{ content: <img src={graph} /> }} disableContentPaddings={true} />
            </div>
            <div>
              <Box variant={'h1'}>Benefits</Box>
              <Container>
                <ColumnLayout columns={2} borders='vertical'>
                  <TextContent>
                    <Box variant={'h3'}>Easier data discovery</Box>
                    <Box variant={'p'}>
                      Discover datasets by searching with familiar business keywords and get the latest metadata such as
                      schema, versions, SLA, etc.
                    </Box>
                  </TextContent>
                  <TextContent>
                    <Box variant={'h3'}>Faster data sharing</Box>
                    <Box variant={'p'}>
                      Simple, self-service, and customer-focused user interface to register your Lake Formation and
                      Redshift catalogs.
                    </Box>
                  </TextContent>
                  <TextContent>
                    <Box variant={'h3'}>Fine-grained data access permission management</Box>
                    <Box variant={'p'}>
                      Tag controls at various levels such as database, schema, dataset, and attribute level.
                    </Box>
                  </TextContent>
                  <TextContent>
                    <Box variant={'h3'}>Secure data governance</Box>
                    <Box variant={'p'}>
                      Provide isolated, secure, and managed Omni workspaces for data consumers to access without
                      bypassing security controls, while enforcing security guardrails and capturing all user actions
                      and query logs for audit.
                    </Box>
                  </TextContent>
                </ColumnLayout>
              </Container>
            </div>
          </SpaceBetween>

          <div className='custom-home__sidebar'>
            <SpaceBetween size={'l'} direction={'vertical'}>
              <Container header={<Header>Discover data</Header>}>
                <SpaceBetween size={'s'} direction={'vertical'}>
                  Start browsing the datasets that are available in AWS.
                  <Button variant='primary' onClick={this.onGetStarted}>
                    {this.props.getStartedBtnText}
                  </Button>
                </SpaceBetween>
              </Container>
              {!this.props.allowListed && (
                <Container header={<Header>Onboard</Header>}>
                  <SpaceBetween size={'s'} direction={'vertical'}>
                    Ready to use Omni? Submit an onboarding request.
                    <Button onClick={this.onOnboarding}>Onboard</Button>
                  </SpaceBetween>
                </Container>
              )}
              <Container header={<Header variant={'h2'}>Learn more</Header>}>
                <ColumnLayout columns={1} borders={'horizontal'}>
                  <Link href={OMNI_WIKI_PAGE} external={true}>
                    What is Omni?
                  </Link>
                  <Link href='https://w.amazon.com/bin/view/AWSDataGovernanceServices/Omni/Onboarding' external={true}>
                    Getting started
                  </Link>
                  <Link href='https://w.amazon.com/bin/view/AWSDataGovernanceServices/Omni/Features/' external={true}>
                    Learn Omni features
                  </Link>
                </ColumnLayout>
              </Container>
            </SpaceBetween>
          </div>
        </Grid>
      </ContentLayout>
    );
  }
}
